import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import { faFileLines } from '@fortawesome/pro-light-svg-icons/faFileLines'
import { faIcons } from '@fortawesome/pro-light-svg-icons/faIcons'
import { faMessageQuestion } from '@fortawesome/pro-light-svg-icons/faMessageQuestion'
import { faMicrophone } from '@fortawesome/pro-light-svg-icons/faMicrophone'
import { faPlay } from '@fortawesome/pro-light-svg-icons/faPlay'
import { faSignalStream } from '@fortawesome/pro-light-svg-icons/faSignalStream'
import { TagColor } from '@space-core/components/customCard/base/enum'

import type { CardTag } from '@space-core/components/customCard/base/types'
import type { PageType } from '@space-shell/common/services/product'

import type { IconKeysType } from './types'

export const DEFAULT_ICON = faIcons

export const TagColors = {
  green: 'green'
}

export const PREVIEW_PERCENTAGE = 50

export const Icons: Record<IconKeysType, IconDefinition> = {
  CONTENT: faFileLines,
  QUIZ: faMessageQuestion,
  WEBINAR: faSignalStream,
  VIDEO: faPlay,
  AUDIO: faMicrophone,

  // TODO change text and icon when should be possible render page ADVERTISEMENT
  ADVERTISEMENT: faMicrophone
}

export const Tags: Record<PageType, CardTag> = {
  WEBINAR: {
    text: 'tags.webinar',
    icon: faSignalStream,
    color: TagColor.RED
  },
  QUIZ: {
    text: 'tags.quiz',
    color: TagColor.GRAY
  },
  CONTENT: {
    text: 'tags.content',
    color: TagColor.GRAY
  },

  // TODO change text and icon when should be possible render page ADVERTISEMENT
  ADVERTISEMENT: {
    text: 'tags.content',
    color: TagColor.GRAY
  }
}
